export class NotificationMonitoringRow {
  static readonly rowID = 'NotificationID' satisfies keyof NotificationMonitoringRow;

  static readonly defaultColumns: (keyof NotificationMonitoringRow)[] = [
    'Type',
    'Timestamp',
    'Severity',
  ] satisfies (keyof NotificationMonitoringRow)[];

  NotificationID!: string;

  Type!: string;

  Timestamp?: string;

  Severity?: string;

  constructor(data: NotificationMonitoringRow) {
    Object.assign(this, data);
  }
}
